define(function() {
  'use strict';

  var APPLICATION_DEBUG_KEY = 'aoflApplicationDebug';

  var enableDebugMode = function enableDebugMode() {
    try {
      localStorage.setItem(APPLICATION_DEBUG_KEY, 'true');
    } catch (e) {
      console.warn('Could not set localStorage key "' +
        APPLICATION_DEBUG_KEY + '"');
    }
  };

  var disableDebugMode = function disableDebugMode() {
    localStorage.removeItem(APPLICATION_DEBUG_KEY);
  };

  var setDebugMode = function setDebugMode(_mode) {
    var mode = _mode || localStorage.getItem(APPLICATION_DEBUG_KEY) === 'true';

    if (mode) {
      enableDebugMode();
    } else {
      disableDebugMode();
    }

    return mode;
  };

  var addGlobalDebugControls = function addGlobalDebugControls($window) {
    $window.enableApplicationDebug = function enableApplicationDebug() {
      enableDebugMode();
      $window.location.reload();
    };
    $window.disableApplicationDebug = function disableApplicationDebug() {
      disableDebugMode();
      $window.location.reload();
    };
  };

  return {
    setDebugMode: setDebugMode,
    addGlobalDebugControls: addGlobalDebugControls
  };
});
